import { Typography } from '@material-ui/core'
import { TypographyProps } from '@material-ui/core/Typography'
import Color from 'color'
import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

type eventSearchContainer = IEventSearchResultProps & ITheme
type details = ISearchResultDetailsProps & ITheme
type container = eventSearchContainer & IWithSize
type result = TypographyProps & IWithSize

export const EventSearchResultContainer = styled.div<container>`
  cursor: pointer;
  padding: ${({ size }) => (size ? 15 * size : 15)}px;
  border-bottom: 1px solid
    ${(props: ITheme) => props.theme.colors.palette.greyTwo};
  background-color: ${(props: IEventSearchResultProps & ITheme) => {
    if (props.isCancelled) {
      return Color(props.theme.colors.palette.slateGrey)
        .alpha(0.1)
        .toString()
    }
    if (props.isICalendar) {
      return Color(props.theme.colors.palette.icalendar)
        .alpha(0.1)
        .toString()
    }
    if (props.isBooking) {
      return Color(props.theme.colors.palette.booking)
        .alpha(0.1)
        .toString()
    }

    return 'transparent'
  }};

  &:hover {
    background-color: ${(props: IEventSearchResultProps & ITheme) => {
      if (props.isCancelled) {
        return Color(props.theme.colors.palette.slateGrey)
          .alpha(0.2)
          .toString()
      }
      if (props.isICalendar) {
        return Color(props.theme.colors.palette.icalendar)
          .alpha(0.2)
          .toString()
      }
      if (props.isBooking) {
        return Color(props.theme.colors.palette.booking)
          .alpha(0.2)
          .toString()
      }

      return Color(props.theme.colors.palette.slateGrey)
        .alpha(0.1)
        .toString()
    }};
  }

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding: ${({ size }) =>
      size ? `${15 * size}px ${20 * size}px` : '15px 20px'};
  }
`
export const EventSearchResultDetailsContainer = styled(Flex as any)`
  flex-basis: 50%;
  min-width: 0;
  flex-grow: 1;
`

export const EventSearchResultDetails = styled(Typography)<details & IWithSize>`
  && {
    font-family: 'Open Sans', sans-serif;
    font-size: ${({ size }) => (size ? 14 * size : 14)}px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.14px;
    text-align: left;
    word-break: break-all;
    color: ${(props: ISearchResultDetailsProps & ITheme) =>
      props.label
        ? props.theme.colors.palette.slateGrey
        : props.theme.colors.palette.darkGreyTwo};
  }
`
export const EventSearchResultName = styled(Typography)<result>`
  && {
    font-family: Montserrat, sans-serif;
    font-size: ${({ size }) => (size ? 14 * size : 14)}px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    word-break: break-all;
    color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
  }
`

interface IEventSearchResultProps {
  isCancelled: boolean
  isICalendar: boolean
  isBooking: boolean
}

interface ISearchResultDetailsProps {
  label?: boolean
}
